module.exports = __webpack_public_path__ + "static/noImage-f471eba56357ed8ea826c1daf48220cd.jpg";